<div class="modal active">
  <div *ngIf="isFirstWindow" class="modal__container" style="width: 40%; overflow-y: hidden">
    <div class="fields">
      <h2>Save Procedure</h2>
      <div class="close" (click)="cancel()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>
      <div class="fields__container">
        <form autocomplete="off"  action="" class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block" style="width: 100%;">
            <div class="fields__block__section">
              <div class="title">
                <h4>Create new procedure or overwrite?</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="newProc">New Procedure</label>
                  <input type="radio" id="newProc" name="procChange" value="newProc" (click)="toggleNewProcedure($event)" [checked]="true" />
                </div>
              </div>

              <div class="input-fields">
                <div>
                  <label for="overwriteProc">Overwrite</label>
                  <input type="radio" id="overwriteProc" name="procChange" value="overwriteProc" (click)="toggleNewProcedure($event)" />
                </div>
              </div>
              <!-- <div class="input-fields" *ngIf="this.newProcedure">
                <div>
                  <label for="newProcID">New Procedure ID</label>
                  <input type="text" id="newProcID" name="newProcID" [(ngModel)]="newProcedureId" [required]="this.newProcedure"/>
                </div>
              </div>
              <div class="input-fields" *ngIf="this.newProcedure">
                <div>
                  <label for="newProcName">New Procedure name</label>
                  <input type="text" id="newProcName" name="newProcName" [(ngModel)]="newProcedureName" [required]="this.newProcedure" />
                </div>
              </div> -->
            </div>
          </div>
          <div class="fields__btn">

            <a (click)="save()" class="blue" style="cursor: pointer;"> Save Procedure </a>

            <a (click)="cancel()" class="gray" style="cursor: pointer;"> Cancel </a>

        </div>
        </form>

      </div>
    </div>
  </div>
  <div *ngIf="!isFirstWindow" class="modal__container" style="width: 50%;overflow-y: hidden">
    <div class="fields">
      <h2>Save Procedure</h2>
      <div class="close" (click)="cancel()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>
      <div class="fields__container">
        <form autocomplete="off"  action="" class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block" style="width: 100%;">
            <div class="fields__block__section">
              <div class="title">
                <h4 id="title2ndWindow" style="width: 100%;">If new points are added to the procedure, please insert an ID and Name for each one.
                  Otherwise, the existing points will be used in the new procedure.</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="newPoints">Create new points</label>
                  <input type="radio" id="newPoints" name="pointsChange" value="newPoints" (click)="toggleNewPoints($event)" [checked]="true" />
                </div>
                <div>
                  <label for="movePoints">Move points</label>
                  <input type="radio" id="movePoints" name="pointsChange" value="movePoints" (click)="toggleNewPoints($event)" [checked]=""  />
                </div>
              </div>
              <div class="table-fields">
                <div>
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Current Id</th>
                          <th scope="col">Current Name</th>
                          <th scope="col">New Point ID</th>
                          <th scope="col">New Point Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of arrayPoints | sort:'sequencenumber'; let i = index;">
                          <td>{{ el.currentId }}</td>
                          <td>{{ el.currentName }}</td>

                           <!-- <td *ngIf="el.coordPoint.> -->

                          <td><input required [disabled]="!newPoints" [(ngModel)]="el.newId"   name="newId_{{i}}"   value="{{ el.newId  }}"  readonly/> </td>
                          <td><input required [disabled]="!newPoints" [(ngModel)]="el.newName" name="newName_{{i}}" value="{{ el.newName }}" readonly/> </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <a (click)="save()" class="blue" style="cursor: pointer;"> Save Procedure </a>
            <a (click)="cancel()" class="gray" style="cursor: pointer;"> Cancel </a>
        </div>
        </form>
      </div>
    </div>
  </div>
</div>
